import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/modules/growing-circle/lib/api";
import { Headphones } from "lucide-react";

const TYPE_LABEL = { podcast: "Podcast", audio: "Audio", reflection: "Reflection", prompt: "Prompt", question: "Question" };

export default function Podcasts() {
  const navigate = useNavigate();
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/contents").then(({ data }) => setContents(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <p className="eyebrow mb-4">Listen</p>
      <h1 className="font-heading text-4xl sm:text-5xl tracking-tight mb-4">The voices of Maria Gioia</h1>
      <p className="text-muted-foreground text-lg max-w-2xl leading-relaxed mb-12">
        Podcasts, reflections and prompts. Each piece can become a starting point for looking within.
      </p>

      {loading ? (
        <p className="text-muted-foreground">One moment…</p>
      ) : contents.length === 0 ? (
        <div className="bg-card border border-border rounded-3xl p-14 text-center">
          <Headphones className="w-10 h-10 mx-auto text-muted-foreground mb-4" />
          <p className="font-heading text-2xl mb-2">No listens yet</p>
          <p className="text-muted-foreground">The first pieces will arrive soon.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-6" data-testid="contents-grid">
          {contents.map((c) => (
            <button key={c.id} onClick={() => navigate(`/growing-circle/podcasts/${c.id}`)} data-testid={`content-card-${c.id}`}
              className="text-left bg-card border border-border rounded-3xl p-8 hover:bg-secondary/40 transition-colors">
              <span className="text-xs uppercase tracking-widest text-accent">{TYPE_LABEL[c.type] || c.type}</span>
              {c.chapter && <span className="text-xs text-muted-foreground ml-2">· {c.chapter}</span>}
              <h3 className="font-heading text-2xl mt-2 mb-2">{c.title}</h3>
              <p className="text-muted-foreground text-sm line-clamp-2">{c.description}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
